let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dM7La")).then(() => parcelRequire('lOY0d'));